const OurCountriesApi = [
    {
        id:1,
        img:"Images/Api/ricardo.jpg",
        title:"SWITZERLAND",
        continent:"Europe",
        description:"Woox Travel is a professional Bootstrap 5 theme HTML CSS layout for your website. You can use this layout for your commercial work.",
        population:" 8.66 Mil People",
        area:"41.290 km",
        value:"$1.100.200",
    },
    {
        id:2,
        img:"Images/Api/claudia.jpg",
        title:"CARIBBEAN",
        continent:"North America",
        description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore dolor sit amet, consectetur adipiscing elit, sed do eiusmod.",
        population:" 44.48 Mil People",
        area:"275.400 km",
        value:"$946.000",
    },
    {
        id:3,
        img:"Images/Api/cyril.jpg",
        title:"FRANCE",
        continent:"Europe",
        description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore dolor sit amet, consectetur adipiscing elit, sed do eiusmod.",
        population:"  67.41 Mil People",
        area:"551.500 km",
        value:"$425.600",
    },
];
export default OurCountriesApi;